import React from 'react';
export default function DragonHeadSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Main head shape */}
      <path d="M8 14 C8 8 14 4 20 4 C26 4 32 8 32 14 L34 24 C34 32 26 38 20 38 C14 38 6 32 6 24 Z" fill="#1A1A2E" />
      {/* Lighter inner face */}
      <path d="M10 16 C10 10 14 6 20 6 C26 6 30 10 30 16 L32 24 C32 30 26 36 20 36 C14 36 8 30 8 24 Z" fill="#2D2B55" />

      {/* Horns */}
      <path d="M10 10 L4 2 L8 8" fill="#1A1A2E" />
      <path d="M30 10 L36 2 L32 8" fill="#1A1A2E" />
      {/* Horn highlights */}
      <path d="M9 9 L5 3" stroke="#3D3B6B" strokeWidth="1" strokeLinecap="round" />
      <path d="M31 9 L35 3" stroke="#3D3B6B" strokeWidth="1" strokeLinecap="round" />

      {/* Glowing purple eyes */}
      <ellipse cx="14" cy="18" rx="3.5" ry="3" fill="#7C4DFF" />
      <ellipse cx="26" cy="18" rx="3.5" ry="3" fill="#7C4DFF" />
      {/* Eye slit pupils */}
      <ellipse cx="14" cy="18" rx="1" ry="2.5" fill="#311B92" />
      <ellipse cx="26" cy="18" rx="1" ry="2.5" fill="#311B92" />
      {/* Eye glow */}
      <ellipse cx="14" cy="18" rx="4" ry="3.5" fill="#B388FF" opacity="0.2" />
      <ellipse cx="26" cy="18" rx="4" ry="3.5" fill="#B388FF" opacity="0.2" />
      {/* Eye shine */}
      <circle cx="12.5" cy="16.5" r="1" fill="white" opacity="0.4" />
      <circle cx="24.5" cy="16.5" r="1" fill="white" opacity="0.4" />

      {/* Snout */}
      <ellipse cx="20" cy="28" rx="7" ry="4" fill="#1A1A2E" />
      {/* Nostrils */}
      <ellipse cx="17" cy="27" rx="1.5" ry="1" fill="#7C4DFF" opacity="0.5" />
      <ellipse cx="23" cy="27" rx="1.5" ry="1" fill="#7C4DFF" opacity="0.5" />

      {/* Mouth line */}
      <path d="M14 30 C16 32 24 32 26 30" stroke="#0D0D1A" strokeWidth="1" fill="none" strokeLinecap="round" />

      {/* Forehead scale pattern */}
      <path d="M18 12 L20 10 L22 12" stroke="#3D3B6B" strokeWidth="0.8" fill="none" />
      <path d="M16 14 L20 11 L24 14" stroke="#3D3B6B" strokeWidth="0.6" fill="none" opacity="0.5" />

      {/* Ambient glow */}
      <circle cx="14" cy="18" r="2" fill="#B388FF" opacity="0.15">
        <animate attributeName="opacity" values="0.1;0.25;0.1" dur="2s" repeatCount="indefinite" />
      </circle>
      <circle cx="26" cy="18" r="2" fill="#B388FF" opacity="0.15">
        <animate attributeName="opacity" values="0.1;0.25;0.1" dur="2s" repeatCount="indefinite" />
      </circle>
    </svg>
  );
}
